import { render, staticRenderFns } from "./SaveOnly.vue?vue&type=template&id=44a5d1ce&scoped=true&"
import script from "./SaveOnly.vue?vue&type=script&lang=ts&"
export * from "./SaveOnly.vue?vue&type=script&lang=ts&"
import style0 from "./SaveOnly.vue?vue&type=style&index=0&id=44a5d1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a5d1ce",
  null
  
)

export default component.exports